import { trackUserJourney } from "../../services/api.service";
import { MockUserJourneyStates } from "./mockUserJourneyStates";


export const makeApiCallOnStepInfo = (title, currentState) => {
    (async () => {
      try {
        let currentStep = currentState.payload.steps;
        let stepInfoPayload = {title: title, steps: currentStep + 1};
        let payload = {...currentState, payload: stepInfoPayload};
       const _userJourney = currentState;
       _userJourney.payload = stepInfoPayload;
       await trackUserJourney(payload);
       return _userJourney;
        
      } catch (e) {
        console.log(e);
      }
    })();
 };

 export const getProgress = (currentState) => {
  let currentStep = currentState.payload.steps;
  return MockUserJourneyStates[currentStep].progress
};

 export const updateUserJourneyState = (currentState) => {
  (async () => {
    try {
      let currentStep = currentState.payload.steps;
      let stepInfoPayload = {title: MockUserJourneyStates[currentStep].stepTitle, steps: MockUserJourneyStates[currentStep].step};
      let payload = {...currentState, payload: stepInfoPayload};
     const _userJourney = currentState;
     _userJourney.payload = stepInfoPayload;
     await trackUserJourney(payload);
     return _userJourney
      
    } catch (e) { 
      console.log(e);
    }
  })();
};




